/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DiscountResultStatus = {
    DISCOUNT: 'DISCOUNT',
    RESULT: 'RESULT'
} as const;
export type DiscountResultStatus = typeof DiscountResultStatus[keyof typeof DiscountResultStatus];

